var CouponView = Backbone.View.extend({
  /**
   * The internal event listeners for the view.
   */
  events: {
    "field-added": "addCoupon",
    "field-removed": "removeCoupon",
    "click [data-remove-coupon-bulk]": "removeCouponBulk"
  },

  /**
   * This method adds a coupon input to the view.
   */
  addCoupon: function() {
    var currentCount = this.$("[data-vendor-coupon-container] > [data-coupon]")
      .length;

    this.renumberCoupons();

    this.$("[data-add-coupon]").attr("data-duplicator-count", currentCount - 1);
  },

  /**
   * This method removes a coupon input from the view.
   */
  removeCoupon: function() {
    var currentCount = this.$("[data-vendor-coupon-container] > [data-coupon]")
      .length;

    this.renumberCoupons();

    this.$("[data-add-coupon]").attr("data-duplicator-count", currentCount - 1);
  },

  removeCouponBulk: function() {
    this.$("[data-remove-coupon]").each(function(index, el) {
      el.click();
    });
  },

  /**
   * This method renumbers the coupons.
   */
  renumberCoupons: function() {
    var counter = 1;

    counter = 1;
    this.$('[data-duplicator-name^="coupon"]').each(function() {
      $(this).attr("data-duplicator-name", "coupon" + counter);
      counter++;
    });
  }
});

module.exports = CouponView;
